import {FC} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const EmailIcon: FC<IconProps> = ({
  color = theme.palette.text.default,
  size = IconSize.small,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.625 3.62012H16.375C17.5486 3.62012 18.5 4.53825 18.5 5.67083V14.3294C18.5 15.462 17.5486 16.3801 16.375 16.3801H3.625C2.4514 16.3801 1.5 15.462 1.5 14.3294V5.67083C1.5 4.53825 2.4514 3.62012 3.625 3.62012ZM3.9184 4.98726L9.49913 10.3729C9.77575 10.6399 10.2242 10.6399 10.5009 10.3729L16.0816 4.98726H3.9184ZM17.0833 5.95397L12.8906 10.0001L17.0833 14.0463V5.95397ZM16.0816 15.013L11.8889 10.9668L11.5026 11.3396C10.6727 12.1405 9.32726 12.1405 8.49739 11.3396L8.11111 10.9668L3.9184 15.013H16.0816ZM2.91667 14.0463L7.10937 10.0001L2.91667 5.95398V14.0463Z"
          fill={color}
        />
      </svg>
    </Icon>
  </>
)
